<div class="spinner-container">
	<div class="yacare-spinner"></div>
</div>
